import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelopeClip = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 5V7L12 12L22 7V5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 20H2V4H22V12", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M19 19V15H16V20C16 21.6569 17.3431 23 19 23C20.6569 23 22 21.6569 22 20V18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconEnvelopeClip.js.map